import apiInstance from './apiInstance';
import { handleUnauth } from './appService';

async function getArchivedAhApplications() {
  try {
    const res = await apiInstance.get('/andrahand/portal/applications/archive');
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getUserAhApplications(userId) {
  try {
    const res = await apiInstance.get(
      `/andrahand/portal/applications/history/${userId}`
    );
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getAhApplication(id) {
  try {
    const res = await apiInstance.get(`/andrahand/portal/applications/${id}`);
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getAhMapCoordinates(applicationId) {
  const { data } = await apiInstance.get(`/map/ah/${applicationId}`);
  return data;
}

async function removeAhApplication(applicationId, reason = '') {
  try {
    const res = await apiInstance.post(
      `/andrahand/portal/applications/${applicationId}/remove`,
      {
        reason
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function rejectAhApplication(applicationId, note) {
  try {
    const res = await apiInstance.post(
      `/andrahand/portal/applications/${applicationId}/reject`,
      {
        note
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function closeAhApplication(applicationId, note) {
  return await apiInstance.post(
    `/andrahand/portal/applications/${applicationId}/close`,
    {
      note
    }
  );
}

async function approveAhApplication(applicationId, { startDate, endDate }) {
  try {
    const res = await apiInstance.post(
      `/andrahand/portal/applications/${applicationId}/approve`,
      {
        startDate,
        endDate
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function getAhApplications() {
  try {
    const res = await apiInstance.get('/andrahand/portal/applications');
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getAhFile(applicationId, uuid) {
  const { data } = await apiInstance.get(
    `/andrahand/portal/documents/${applicationId}/${uuid}`,
    {
      responseType: 'blob'
    }
  );
  return data;
}

async function restoreAhApplication(applicationId) {
  await apiInstance.post(
    `/andrahand/portal/applications/${applicationId}/restore`
  );
}

async function getSubletStatistics() {
  const res = await apiInstance.get('/statistics/andrahand');
  return res.data;
}

export {
  approveAhApplication,
  rejectAhApplication,
  getArchivedAhApplications,
  getAhMapCoordinates,
  removeAhApplication,
  getAhApplications,
  getAhApplication,
  getAhFile,
  closeAhApplication,
  getUserAhApplications,
  restoreAhApplication,
  getSubletStatistics
};
